import React, { Component } from "react";

import TwoPanels from "./TwoPanels";
import Text from "./Text";

class MarketingNoUnitsSold2 extends Component {
  render() {
    return (
      <TwoPanels
        title1="Little to No Units Sold - Product Market Fit"
        title2="Potential Reasons"
      >
        <fragment>
          <Text>
            Your business didn’t sell any units this round because the Marketing
            Mix of the following products did not meet any of the 14 customer
            requirements and therefore, no customer bought the following
            products.
          </Text>
          <div>
            <ul>
              Product Name
              <li>Mob 1</li>
              <li>Mob 2</li>
              <li>Mob 3</li>
            </ul>
          </div>
        </fragment>
        <fragment>
          <Text>
            <h3>Minimum Requirements:</h3> Product did not meet minimum customer
            requirements. Please review Customer Analysis and cross-refeerence
            their perferences with your product's features.
          </Text>

          <Text>
            <h3>Pricing and Feature Preferences:</h3>Product's pricing and
            features were not aligned with customers. If pricing was out of
            mobile customers range, then your mobile market potentional is
            reduced to 25% or less and 0% if the price was $15.00 or higher. If
            pricing was out of auto customers range, then your auto market
            potentional is reduced to 25% or less and 0% if the price was $40.00
            or higher.
          </Text>

          <Text>
            <h3>Sales Channel Preferences:</h3> Product's distribution channels
            were not alignd with customers. The misalignment would further
            reduce your market potentional by 50%.
          </Text>
        </fragment>
      </TwoPanels>
    );
  }
}

export default MarketingNoUnitsSold2;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingNoUnitsSold2.js